import React, {useCallback, useRef} from 'react'
import classNames from 'classnames'

import {useTranslation} from '@lib/intl/useTranslations'
import {createLog} from '@util/logs'

import Text from '@component/Text/Text'
import WizIconButton from '@component/buttons/WizIconButton'
import SearchModal from '@feature/leaderboard/components/SearchModal/SearchModal'

import IconSearch from '@svg/common/ic_search.svg'

const SearchBar = () => {
    const t = useTranslation()
    const searchModalRef = useRef<any>()

    const openModal = useCallback(() => {
        searchModalRef.current.show()
    }, [])

    const onClickSearch = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e?.cancelable) {
            e.preventDefault()
        }
        createLog('event', 'leaderboard_user_search')
        openModal()
    }

    return (
        <>
            {/* Web only */}
            <div
                className={classNames(
                    'flex items-center gap-x-[10px] cursor-pointer rounded-full',
                    'min-w-[185px] p-[9.5px]',
                    'bg-white dark:bg-bg_dark_white02',
                    'border border-gray05 dark:border-dark_gray05',
                    'hover:border-gray01 dark:hover:border-dark_gray01',
                    'md:hidden',
                )}
                onClick={onClickSearch}>
                <IconSearch className={'w-[16px] fill-gray02 dark:fill-dark_gray02'} />
                <Text className={'text-body2 text-gray03 dark:text-dark_gray03'}>
                    {t('leaderboard.searchUser.input.placeholder')}
                </Text>
            </div>

            {/* Mobile only */}
            <WizIconButton onClick={onClickSearch} className={'hidden md:block p-[10px]'}>
                <IconSearch className={'w-[18px] fill-gray01 dark:fill-dark_gray01'} />
            </WizIconButton>

            <SearchModal ref={searchModalRef} />
        </>
    )
}

export default React.memo(SearchBar, () => true)
